import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./sass/main.scss";
import App from "./components/App";

ReactDOM.render(<App />, document.getElementById("root"));
